import type { ReactNode } from "react";
import styles from "./Tabs.module.css";

export interface TabItem {
  key: string;
  label: ReactNode;
}

interface TabsProps {
  items: TabItem[];
  value: string;
  onChange: (key: string) => void;
  variant?: "underline" | "pill";
}

/** Underline/pill tab strip. Matches library-inputs.jsx `Tabs`. */
export function Tabs({ items, value, onChange, variant = "underline" }: TabsProps) {
  return (
    <div className={`${styles.row} ${styles[variant]}`} role="tablist">
      {items.map((it) => (
        <button
          key={it.key}
          role="tab"
          aria-selected={it.key === value}
          className={`${styles.tab} ${it.key === value ? styles.active : ""}`}
          onClick={() => onChange(it.key)}
          type="button"
        >
          {it.label}
        </button>
      ))}
    </div>
  );
}
